import { WebsitePageLocale } from 'src/shared/types/website-page-interface'
import {
  getWebsitePageContentIdFromPlaceholder,
  isWebsitePageUrlPlaceholderValue,
} from './website-replacements-utils'

export const isWebsitePageLinkVisible = (
  link: string,
  activePageIds: WebsitePageLocale['id'][] | undefined,
) => {
  if (!isWebsitePageUrlPlaceholderValue(link)) {
    return true
  }

  const pageContentId = getWebsitePageContentIdFromPlaceholder(link)

  if (!activePageIds?.length || !pageContentId) {
    return true
  }

  return activePageIds.includes(pageContentId)
}
